import React, { useCallback } from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { EmailFieldContent, EmailValidationState } from '@shared/components/EmailFieldContent';

export const EMail = <T extends FieldValues>({
  control,
  defaultValue,
  errorMessage,
  name,
  isDisabled,
  setWidth,
  emailValidation,
}: UseControllerProps<T> & {
  errorMessage?: string;
  isDisabled?: boolean;
  setWidth?: boolean;
  emailValidation?: EmailValidationState;
}) => {
  const renderField = useCallback(
    ({ field: { value, onChange } }) => (
      <EmailFieldContent
        value={value}
        onChange={onChange}
        editable={!isDisabled}
        errorMessage={errorMessage}
        emailValidation={emailValidation}
        label="E-post"
        setWidth={setWidth}
      />
    ),
    [isDisabled, errorMessage, emailValidation, setWidth],
  );

  return <Controller name={name} control={control} defaultValue={defaultValue} render={renderField} />;
};
